import { Typography } from './typography.js'

export * from './typography.js'

export default Typography
